import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=d7b2e4bc&scoped=true&"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js&"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7b2e4bc",
  null
  
)

export default component.exports